import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api, erroMsg } from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    try {
      const raw = localStorage.getItem("sky_user");
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  });
  const [carregando, setCarregando] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("sky_token");
    if (!token) {
      setCarregando(false);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => {
        setUser(r.data);
        localStorage.setItem("sky_user", JSON.stringify(r.data));
      })
      .catch(() => setUser(null))
      .finally(() => setCarregando(false));
  }, []);

  const login = useCallback(async (email, senha) => {
    try {
      const r = await api.post("/auth/login", { email, senha });
      localStorage.setItem("sky_token", r.data.token);
      localStorage.setItem("sky_user", JSON.stringify(r.data.user));
      setUser(r.data.user);
      return { ok: true, user: r.data.user };
    } catch (e) {
      return { ok: false, erro: erroMsg(e, "Não foi possível entrar.") };
    }
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("sky_token");
    localStorage.removeItem("sky_user");
    setUser(null);
    window.location.href = "/login";
  }, []);

  const value = useMemo(
    () => ({ user, setUser, login, logout, carregando, isAdmin: user?.role === "admin" }),
    [user, login, logout, carregando]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth precisa estar dentro de AuthProvider");
  return ctx;
};
